import React, { memo } from "react";

import { Box, HStack, Text, VStack } from "@chakra-ui/react";

import UserName from "modules/_shared/user-name";
import prettyBytes from "pretty-bytes";
import moment from "moment";
import { FILE_DAY_YEAR_FORMAT } from "modules/utils/Constants";
import colors from "app/colors";
import { FileGalleryFragment, MessageFragment } from "gql/graphql";
import MessageReactions from "modules/messaging/messages/message-reactions";

interface IProps {
  message?: MessageFragment;
  file: FileGalleryFragment;
}

const FileGalleryHeader = ({ message, file }: IProps) => (
  <VStack w="full" alignItems="center" spacing={0}>
    <HStack>
      <Text color={colors.white}>{file.name}</Text>
      <Text color={colors.grayMain} fontSize={14}>
        {prettyBytes(file.byteCount, {
          binary: true,
        })}
      </Text>
      <MessageReactions message={message} file={file} />
    </HStack>
    <HStack>
      <Box color={colors.grayMain}>
        <HStack>
          <Text fontSize={14}>
            <UserName userId={file.userId} />
          </Text>
          <Text fontSize={14}>&#x2022;</Text>
          <Text fontSize={14}>
            {moment(file.createTime).format(FILE_DAY_YEAR_FORMAT)}
          </Text>
        </HStack>
      </Box>
    </HStack>
  </VStack>
);

export default memo(FileGalleryHeader);
